import React from 'react'
import { AboutComponent } from '../../components'

const About = () => {
  return (
    <div>
      <AboutComponent />
    </div>
  )
}

export default About
